import { render, staticRenderFns } from "./UTMList.vue?vue&type=template&id=c6108906&"
import script from "./UTMList.vue?vue&type=script&lang=js&"
export * from "./UTMList.vue?vue&type=script&lang=js&"
import style0 from "./UTMList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports